<template lang="pug">
    multiselect(
        v-model="selected",
        :multiple="true"
        :close-on-select="true",
        :clear-on-select="false",
        :options="options",
        :show-labels="true"
        deselect-label="X",
        select-label="mit Enter auswählen",
        selected-label="ausgewählt",
        :placeholder="filter.name"
    )
</template>
<script>
//import Components
import Multiselect from 'vue-multiselect'
import get from 'lodash.get'

export default {
    name: "Select",
    components: {
        Multiselect
    },
    data() {
        return {
            selectedValues: ''
        }
    },
    props: {
        filter: {
            type: Object,
            required: true
        },
    },
    computed: {
        selected: {
            get() {
                return this.selectedValues
            },
            set(value) {
                this.selectedValues = value;
                let key = this.filterKey;
                let payload = {};
                payload = {
                    key,
                    value
                };
                this.$emit('changedFilter', payload)
            }
        },
        options() {
            let options = []
            this.filter.pages.forEach(page => {
                options.push(get(page.pivot, 'value'))
            })
            options = options.filter((value, index) => options.indexOf(value) === index).sort();
            if (this.filter.key === 'alter') {
                options.forEach((item, i) => {
                    if (item === '<18' || item === '>18') {
                        options.splice(i, 1);
                        options.unshift(item);
                    }
                });
            }

            return options;
        },
        filterKey() {
            return this.filter.key;
        }
    },
}
</script>
<style lang="sass" scoped>
    @import '~@/assets/sass/variables'
    ::v-deep
        .multiselect__tag-icon:focus, 
        .multiselect__tag-icon:hover,
        .multiselect__tag-icon:after
            color: $color-primary

        .multiselect__placeholder
            font-weight: 600 !important
            color: $color-base-text !important
</style>